import { withSvgIcon } from './withSvgIcon';

export const Lock = withSvgIcon(
  <>
    <path
      d="M16 11H8C6.89543 11 6 11.8954 6 13V18C6 19.1046 6.89543 20 8 20H16C17.1046 20 18 19.1046 18 18V13C18 11.8954 17.1046 11 16 11Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M8 11V8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8V11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
